import type { LiveContextType, LiveDataPath } from "../modules/live";

/**
 * contextId の先頭 3 文字を LiveContextType として返す。
 * contextId は redux store から渡される `qid_xxx` / `vid_xxx` / `cid_xxx` / `did_xxx`
 * 形式の tagged ID で、prefix がそのまま種類を表す前提。
 *
 * NOTE: `as LiveContextType` は runtime 検証なしの unsafe cast。
 * prefix が想定外の値だった場合も `LiveContextType` として扱われてしまう。
 * 本来は type guard で narrow して null を返すべきだが、
 * 挙動を変えずに型エラーだけ消したいため一旦 as で対応している。
 * TODO: テストを追加した上で runtime validation (type guard) に置き換える。
 */
export const getLiveContextType = (
  contextId: string
): LiveContextType | null => {
  return !contextId ? null : (contextId.slice(0, 3) as LiveContextType);
};

export const getLiveContextWord = (contextId: string) => {
  switch (getLiveContextType(contextId)) {
    case "qid":
      return "クイズ";
    case "cid":
      return "タップ";
    default:
      return "";
  }
};

export const getLiveDataPath = (
  contextIdType: LiveContextType | null
): LiveDataPath | null => {
  switch (contextIdType) {
    case "cid":
      return "clicks";
    case "qid":
      return "surveys";
    default:
      return null;
  }
};
